import type { CompanyConfiguration } from '../services/configuration.service';

// Application identity stays local because Vision24 and SecureView share the API.
export const APP_BRAND = {
  name: 'Vision 24',
  logoUrl: '/logo192.png',
  faviconUrl: '/favicon.ico',
  primaryColor: '#D32F2F',
  secondaryColor: '#EF5350',
} as const;

export const withAppBranding = (config: CompanyConfiguration): CompanyConfiguration => ({
  ...config,
  brand_name: APP_BRAND.name,
  logo_url: APP_BRAND.logoUrl,
  favicon_url: APP_BRAND.faviconUrl,
  primary_color: APP_BRAND.primaryColor,
  secondary_color: APP_BRAND.secondaryColor,
  login_title: (config.login_title || 'Welcome to Vision 24').replace(/SecureView/gi, APP_BRAND.name),
  footer_text: (config.footer_text || '© 2026 Vision 24. All rights reserved.').replace(/SecureView/gi, APP_BRAND.name),
});
